export const npShiftsOptions = [
    { key: "al", text: "Albania", value: "al" },
    { key: "at", text: "Austria", value: "at" },
    { key: "be", text: "Belgium", value: "be" },
    { key: "ba", text: "Bosnia and Herzegovina", value: "ba" },
    { key: "bg", text: "Bulgaria", value: "bg" },
    { key: "hr", text: "Croatia", value: "hr" },
    { key: "cz", text: "Czech Republic", value: "cz" },
    { key: "dk", text: "Denmark", value: "dk" },
    { key: "fr", text: "France", value: "fr" },
    { key: "de", text: "Germany", value: "de" },
    { key: "gr", text: "Greece", value: "gr" },
    { key: "hu", text: "Hungary", value: "hu" },
    { key: "it", text: "Italy", value: "it" },
    { key: "md", text: "Moldova", value: "md" },
    { key: "me", text: "Montenegro", value: "me" },
    { key: "nl", text: "Netherlands", value: "nl" },
    { key: "mk", text: "North Macedonia", value: "mk" },
    { key: "pl", text: "Poland", value: "pl" },
    { key: "pt", text: "Portugal", value: "pt" },
    { key: "ro", text: "Romania", value: "ro" },
    { key: "rs", text: "Serbia", value: "rs" },
    { key: "sk", text: "Slovakia", value: "sk" },
    { key: "si", text: "Slovenia", value: "si" },
    { key: "es", text: "Spain", value: "es" },
    { key: "ch", text: "Switzerland", value: "ch" },
    { key: "ua", text: "Ukraine", value: "ua" },
    { key: "tr", text: "Turkey", value: "tr" },
];

export const coreCountries = [
    "at",
    "be",
    "de",
    "si",
    "hr",
    "hu",
    "sk",
    "cz",
    "pl",
    "fr",
    "ro",
    "nl",
    "be_al",
    "de_al",
];

export interface IPublicationDocument {
    attributes: IDocumentAttributes;
    creationDateTime: IPublicationDocumentChild;
    documentIdentification: IPublicationDocumentChild;
    documentType: IPublicationDocumentChild;
    documentVersion: IPublicationDocumentChild;
    publicationTimeInterval: IPublicationDocumentChild;
    publicationTimeSeries: IPublicationTimeSerie[];
    receiverIdentification: IPublicationDocumentChild;
    receiverRole: IPublicationDocumentChild;
    senderIdentification: IPublicationDocumentChild;
    senderRole: IPublicationDocumentChild;
}

export interface IPublicationTimeSerie {
    "#text": string;
    businessType: IAttributes;
    inArea: IAttributes;
    measureUnitQuantity: IAttributes;
    outArea: IAttributes;
    period: IPeriod;
    timeSeriesIdentification: IAttributes;
}

interface IPeriod {
    "#text": string;
    interval: IInterval[];
    resolution: IAttributes;
    timeInterval: IAttributes;
}

interface IInterval {
    "#text": string;
    pos: IAttributes;
    qty: IAttributes;
}

interface IPublicationDocumentChild {
    attributes: IAttributes;
}

interface IDocumentAttributes {
    dtdRelease: string;
    dtdVersion: string;
    "xmlns:xsi": string;
    "xsi:noNamespaceSchemaLocation": string;
}

interface IAttributes {
    attributes: { codingScheme?: string; v: string };
}

export interface ITableValues extends Record<string, number> {
    al: number;
    at: number;
    ba: number;
    be: number;
    bg: number;
    ch: number;
    cz: number;
    de: number;
    dk1: number;
    es: number;
    fr: number;
    gr: number;
    hr: number;
    hu: number;
    it: number;
    me: number;
    md: number;
    mk: number;
    nl: number;
    pl: number;
    pt: number;
    ro: number;
    rs: number;
    si: number;
    sk: number;
    tr: number;
    ua: number;
    be_al: number;
    de_al: number;
}

export const tableValuesInit: ITableValues = {
    al: 0,
    at: 0,
    ba: 0,
    be: 0,
    bg: 0,
    ch: 0,
    cz: 0,
    de: 0,
    dk1: 0,
    es: 0,
    fr: 0,
    gr: 0,
    hr: 0,
    hu: 0,
    it: 0,
    me: 0,
    md: 0,
    mk: 0,
    nl: 0,
    pl: 0,
    pt: 0,
    ro: 0,
    rs: 0,
    si: 0,
    sk: 0,
    tr: 0,
    ua: 0,
    be_al: 0,
    de_al: 0,
};
